var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        { name: "toggle-basket-preview", rawName: "v-toggle-basket-preview" }
      ],
      staticClass: "toggle-basket-preview",
      attrs: { href: "#" }
    },
    [
      _c(
        "svg",
        {
          staticClass: "header__shopping-bag",
          attrs: { fill: "currentColor" }
        },
        [_c("use", { attrs: { "xlink:href": "#shopping-bag" } })]
      ),
      _vm._v(" "),
      _vm.getItemQuantity > 0
        ? _c("div", { staticClass: "header__shopping-bag-qty-badge" }, [
            _c("span", [_vm._v(_vm._s(_vm.getItemQuantity))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.$translate("HoferAntikschmuck::Template.headerBasketLabel")
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }